<picture aria-hidden="true">
  @for (source of srcSet(); track source.src) {
    <source [attr.srcset]="source.src" media="(min-width: {{ source.width }}px)" />
  }
  <!-- if alt text is present on this element, the low quality image placeholder background will shrink to the size of the text -->
  <!-- eslint-disable-next-line @angular-eslint/template/alt-text -->
  <img
    class="low-quality-image-placeholder fill"
    [attr.src]="originalSrc()"
    [ngClass]="{ 'fill-parent': fillParent(), scale: scale() }"
    [attr.loading]="loading()"
    [attr.decoding]="decoding()"
    [attr.fetchpriority]="fetchPriority()"
    [class]="aspectRatioClass()"
    [style.--lqip]="lqip()"
    [style.aspect-ratio]="customAspectRatio()"
  />
</picture>
@if (alt()) {
  <img class="is-vishidden" aria-hidden="false" [attr.alt]="alt()" />
}
